import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 9l3 3l-3 3","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-1"}]]

const IconSquareRoundedChevronRight = createReactComponent('outline', 'square-rounded-chevron-right', 'SquareRoundedChevronRight', __iconNode);

export default IconSquareRoundedChevronRight;